import he from 'he';
import fp from 'lodash/fp';
import React from 'react';
import { Col, Collapse, Row } from 'react-bootstrap';
import { withHandlers, withStateHandlers } from 'recompose';
import { compose } from 'redux';
import { Icon } from '..';
import ControlGroup from '../control-group';
import ControlOption from '../control-option';

const cpdCategoryProps = (cpdCategory) => ({
  key: cpdCategory.id,
  value: cpdCategory.id,
  checked: cpdCategory.selected,
  label: <span>{he.decode(cpdCategory.name)}</span>
})

const CpdCategoryFilter = ({
  onCpdCategoryFilterChange,
  toggleFilter,
  showFilter,
  cpdCategorys
}) => (
    <div className='filter cpd-category-filter'>
      <Row className='button-gutter'>
        <Col xs={12}>
          <h2
            className='flexbox justify-between'
            type='button'
            onClick={toggleFilter}
            aria-expanded={showFilter}
            aria-controls='filter'>
            Filter by CPD category
            {
              showFilter ?
                <Icon icon='minus-large'></Icon> :
                <Icon icon='plus-large'></Icon>
            }
          </h2>
        </Col>
      </Row>
      <Collapse id='filter' in={showFilter}>
        <form>
          <fieldset>
            <ControlGroup id='area-of-advice' className='no-margin' control='checkbox' type='styled' label={null} colProps={{ xs: 12, sm: 4, md: 2 }} onChange={onCpdCategoryFilterChange}>
              {
                fp.flow(
                  fp.filter(aoa => !aoa.legacy),
                  fp.sortBy(aoa => aoa.name),
                  fp.map(aoa => <ControlOption className='no-margin' {...cpdCategoryProps(aoa)} />)
                )(cpdCategorys)
              }
            </ControlGroup>
          </fieldset>
        </form>
      </Collapse>
    </div>
  )

const getUpdatedCpdCategorys = (cpdCategorys, cpdCategoryIdToToggle) => fp.flow(
  fp.map(
    (cpdCategory) => ({
      ...cpdCategory,
      selected: cpdCategory.id === cpdCategoryIdToToggle ? !cpdCategory.selected : cpdCategory.selected
    })
  )
)(cpdCategorys)

export default compose(
  withStateHandlers(
    {
      showFilter: false
    },
    {
      toggleFilter: ({ showFilter }) => () => ({
        showFilter: !showFilter
      })
    }
  ),
  withStateHandlers(
    ({ cpdCategorys }) => ({
      cpdCategorys: fp.map(
        (cpdCategory) => ({
          ...cpdCategory,
          selected: false
        })
      )(cpdCategorys)
    }),
    {
      setCpdCategorys: () => (cpdCategorys) => ({
        cpdCategorys
      })
    }
  ),
  withHandlers({
    onCpdCategoryFilterChange: ({ onChange, cpdCategorys, setCpdCategorys }) => (e) => {
      const cpdCategoryId = parseInt(e.target.value, 10)
      const updatedCpdCategorys = getUpdatedCpdCategorys(cpdCategorys, cpdCategoryId)
      setCpdCategorys(updatedCpdCategorys)
      const selectedCpdCategoryIds = fp.flow(
        fp.filter('selected'),
        fp.map('id')
      )(updatedCpdCategorys)
      onChange(selectedCpdCategoryIds)
    }
  })
)(CpdCategoryFilter)


// WEBPACK FOOTER //
// ./src/containers/components/filters/cpd-category-filter.js